'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosFilingOutline = function IoIosFilingOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm28.5 10l5 7.5v12.5h-27.5v-12.5l5-7.5h17.5z m3.5 7.5l-3.5-5.3v5.3h3.5z m-19.7-6.2v6.2h3.7c0 2 1.7 3.8 3.8 3.8s3.7-1.8 3.7-3.8h3.8v-6.2h-15z m-1.3 0.9l-3.5 5.3h3.5v-5.3z m21.3 16.6v-10h-7.7c-0.6 2.1-2.5 3.7-4.8 3.7s-4.3-1.6-4.9-3.7h-7.6v10h25z' })
        )
    );
};

exports.default = IoIosFilingOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-filing-outline.js
// module id = 2387
// module chunks = 0